/**
 * Global Colors
 */
export const GREY = "#808080";

export type Color = {
    name: string;
    session: string;
    free_slot: string;
    canceled: string;
};

export const COLORS: Color[] = [
    {
        name: "Navy Blue",
        session: "#314F6F",
        free_slot: "#7198c1",
        canceled: "#808080"
    },
    {
        name: "Red",
        session: "#d54c48",
        free_slot: "#e48784",
        canceled: "#808080"
    },
    {
        name: "Olive Green",
        session: "#686b2e",
        free_slot: "#ced194",
        canceled: "#808080"
    },
    {
        name: "Burgundy",
        session: "#6C094F",
        free_slot: "#EED9E2",
        canceled: "#808080"
    },
    {
        name: "Orange",
        session: "#ec9c3d",
        free_slot: "#F9E7D4",
        canceled: "#808080"
    },
    {
        name: "Deep Red",
        session: "#d84315",
        free_slot: "#ffab91",
        canceled: "#808080"
    },
    {
        name: "Slate Gray",
        session: "#808B96",
        free_slot: "#D5D8DC",
        canceled: "#808080"
    },
    {
        name: "Lime Green",
        session: "#76B81B",
        free_slot: "#C1EA99",
        canceled: "#808080"
    },
    {
        name: "Pink",
        session: "#C720A1",
        free_slot: "#F7CBEC",
        canceled: "#808080"
    },
    {
        name: "Mauve",
        session: "#A0676E",
        free_slot: "#DDC9CC",
        canceled: "#808080"
    },
    {
        name: "Dark Gray",
        session: "#1A1A1A",
        free_slot: "#505050",
        canceled: "#808080"
    },
    {
        name: "Charcoal",
        session: "#2E2E2E",
        free_slot: "#6F6F6F",
        canceled: "#808080"
    },
    {
        name: "Almost Black",
        session: "#0F0F0F",
        free_slot: "#3A3A3A",
        canceled: "#808080"
    },
    {
        name: "Dark Burgundy",
        session: "#330B20",
        free_slot: "#6D4C61",
        canceled: "#808080"
    },
    {
        name: "Brown",
        session: "#5A3D1B",
        free_slot: "#99765A",
        canceled: "#808080"
    },
    {
        name: "Dark Red",
        session: "#45110F",
        free_slot: "#7D524D",
        canceled: "#808080"
    },
    {
        name: "Dark Slate",
        session: "#2C3338",
        free_slot: "#5F686D",
        canceled: "#808080"
    },
    {
        name: "Forest Green",
        session: "#3E6011",
        free_slot: "#8EAD43",
        canceled: "#808080"
    },
    {
        name: "Deep Pink",
        session: "#7F0254",
        free_slot: "#AF4D79",
        canceled: "#808080"
    },
    {
        name: "Gray Purple",
        session: "#594E52",
        free_slot: "#8F878B",
        canceled: "#808080"
    }
];

// export const getRandomColor = () => {
//     const randomIndex = Math.floor(Math.random() * COLORS.length);
//     return COLORS[randomIndex];
// };

export const getColorByIndex = (index: number) => COLORS[index % 10];
